import * as Sentry from "@sentry/react";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../service/globalValues";
import { protectDataProducerSheet } from "../service/producerServices/lockEditModeInSomeColumns";
import { InsertUpdatedSecurityValues } from "../service/store/types";
import { onSingleClicked } from "./onSingleClicked";
import { cellUpdateHandler } from "./utils";

interface RegisterEventHandlersArgs {
  onSaveSecurityInStaging: (data: InsertUpdatedSecurityValues) => Promise<void>;
  onSetQuoteFeedAsNone: ({ securityProducerId }: { securityProducerId: string }) => void;
  onUploadData: ({ securityId, updatedRow }: { securityId: string; updatedRow: number }) => Promise<void>;
}

let onCalculatedEvent, onChangedEvent, onSingleClickedEvent;

export const registerEventHandlers = async ({
  onSaveSecurityInStaging,
  onUploadData,
  onSetQuoteFeedAsNone,
}: RegisterEventHandlersArgs) => {
  await removeEventHandlers();

  try {
    await Excel.run(async (context) => {
      const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);

      worksheet.protection.unprotect();

      onChangedEvent = worksheet.onChanged.add(({ address }) =>
        cellUpdateHandler({ address, onSaveSecurityInStaging, onSetQuoteFeedAsNone })
      );

      onCalculatedEvent = worksheet.onCalculated.add(({ address }) =>
        cellUpdateHandler({ address, onSaveSecurityInStaging, onSetQuoteFeedAsNone })
      );

      onSingleClickedEvent = worksheet.onSingleClicked.add((event) =>
        onSingleClicked({ event, uploadData: onUploadData })
      );

      await protectDataProducerSheet({ worksheet });

      await context.sync();
    });
  } catch (error) {
    Sentry.captureException(
      new Error('Error while registering data changed handler', { cause: error })
    );
  }
};

const removeEventHandlers = async () => {
  try {
    for (let element of [onCalculatedEvent, onChangedEvent, onSingleClickedEvent]) {
      await Excel.run(element.context, async (context) => {
        element.remove();
        await context.sync();
      });
    }
  } catch (error) {
    console.log("Error while removing event handlers: %s");

    Sentry.captureException(
      new Error('Error while removing event handlers', { cause: error })
    );
  }
};
